import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const WorkflowIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 29 18.6"
    >
      <g transform="translate(1 1)">
        <path
          d="M1418.51,82.68H1408.1a13.5,13.5,0,0,1,27,0h-10.442"
          transform="translate(-1408.098 -69.2)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M1421.569,79.636a3.082,3.082,0,1,1-3.087,3.082A3.084,3.084,0,0,1,1421.569,79.636Z"
          transform="translate(-1408.098 -69.2)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          y1="3.876"
          x2="3.881"
          transform="translate(15.71 7.407)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
